<template>
	<section v-if="getOs">
        <div id="card_cliente">
            <div id="card_title" class="text-align-start">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Clientes</span>
            </div>
            <div id="card_body" >
            </div>
        </div>
                <div class="search-wrapper panel-heading">
                    <input class="form-control" type="text" v-model="searchQuery" placeholder="Busque por um cliente" />
                </div>
                <div style="overflow-y: scroll; height: 65vh">
                    <table class="tables" style="width: 100%">
                        <tbody>
                            <tr v-for="el in tableFilter" :key='el.id'>
                                <td class="text-center" @click.prevent="showDetails(el.id)">{{el.fantasy_name}}</td>
                            </tr>
                        </tbody>
			        </table>
                </div>
        <div class="modal" id="clientModal">
            <div class="modal-content">
                <div class="formHeader" style="text-align: start">
                    <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                    <span style="vertical-align: middle; font-weight: 600">Detalhes do cliente</span>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="id" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.id"
                                />
                            </div>
                        </div>
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="fantasy_name" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.fantasy_name"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="cpf_cnpj" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.cpf_cnpj"
                                />
                            </div>
                        </div>
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="address" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.address"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="number" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.number"
                                />
                            </div>
                        </div>
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="district" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.district"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="city" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.city"
                                />
                            </div>
                        </div>
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="uf" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.uf"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="cep" >
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.cep"
                                />
                            </div>
                        </div>
                        <div class="column" style="flex: 1">
                            <div class="input-group-prepend" id="complement">
                                <span class="input-group-text">
                                    <i class="fas fa-ticket-alt"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="client.complement"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <button class="btn btn-danger" style="width: 10em" @click.prevent="closeDetails()"><i class="fas fa-window-close fa-fw"></i> Fechar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    data(){
        return{
            obj: [],
            searchQuery:'',
            client: {
                id: '',
                cpf_cnpj: '',
                fantasy_name: '',
                address: '',
                number: '',
                district: '',
                city: '',
                uf: '',
                cep: '',
                complement: '',
            }

        }
    },
    computed:{
    ...mapGetters(['getAllOcorrence', 'occurrence','getChamados','getOs']),

	},
    methods:{
        ...mapActions(['fetchOcurrences', 'findLogById', 'receivelog', 'setModalCadastro']),


    },
    mounted(){
        // this.receivelog();
    },
    created(){
		// axios.get('/getAllClients').then(data => {
        //     console.log(data.data)
        //     this.obj = data.data
        // })
    },

}

</script>

<style scoped>

    .row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        align-items: center;
    }

    .column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1
    }

    .input-group-prepend {
        margin: .1em;
        padding: .1em;
    }

    .modal {
      display: none; /* Hidden by default */
      position: absolute; /* Stay in place */
      z-index: 1; /* Sit on top */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow: auto; /* Enable scroll if needed */
      background-color: rgb(0,0,0); /* Fallback color */
      background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    .modal-content {
      background-color: #fefefe;
      margin: 15% auto; /* 15% from the top and centered */
      padding: 20px;
      border: 1px solid #888;
      width: 50%; /* Could be more or less, depending on screen size */
      padding: 0
    }

    .close {
        color: #aaa;
        float: right;
        font-size: 28px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
      color: black;
      text-decoration: none;
      cursor: pointer;
    }

    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
    }

    #card_body {
        border: 1px solid lightgray;
        margin-top: 0;
        cursor: pointer;
    }

    #card_title {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;

    }

    th {
        vertical-align: middle;
        color: gray;
        background-color:white;
        padding: 0;
    }

    td {
        padding: 0.2em;
    }

    table{
        border: 1px solid lightgray;
    }

    tr:hover{
        background-color: rgba(170, 170, 170, 1);
    }
    td:hover{
        background-color: rgba(191, 170, 170, 1);
    }
    .button-page{
        margin-top:0px;
        float:right;
        margin-right: 0.5em;
    }
    .no-border{
        border: hidden;
        background: none;
    }

    .col-md-12 {
        max-width:80%;
        margin-left: 10px;
    }

	@media screen and (max-width: 1489px) {

        .table-low-res{
            height: 33em;
            overflow: auto;
        }

	}
    @media screen and (max-width: 941px){
        .table-low-res{
            height: 30em;
            overflow: auto;
        }
    }

	#tituloChamados {
		line-height: 5;
		text-align: center;
		color: rgb(28,134,154);
	}

	#botaoNovoChamado {
		float: left;
    	position: absolute;
    	height: 100px;
    	margin-left: 50px;
    	width: 100px;
    	border: solid 3px rgb(28,134,154);
		border-radius: 15px;
	}

</style>
